import React, { Fragment } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRouter'
import { RouteAccess } from './RouteAccess';

import { HomePage } from '../pages/home/HomePage';

import { LoginPage } from '../pages/login/LoginPage';
import { SignupPage } from '../pages/signup/SignupPage';
import { ActivationPage } from '../pages/activation/ActivationPage';
import { FormForgetPasswordEmail } from '../pages/forgetPassword/FormForgetPasswordEmail';
import { FormForgetPassword } from '../pages/forgetPassword/FormForgetPassword';
import { AddNewUserPage } from '../pages/users/AddNewUserPage';

import { NotFoundPage } from '../pages/notFound/NotFoundPage';

import { ToasterProvider } from '../providers/ToasterProvider';
import { PreRegistrationPage } from '../pages/preRegistration/PreRegistrationPage';
import { CandidatesPage } from '../pages/candidates/CandidatesPage';
import { StudentsPage } from '../pages/students/StudentsPage';
import { UsersPage } from '../pages/users/UsersPage';
import { PaymentsPage } from '../pages/payments/PaymentsPage';
import { SettingPage } from '../pages/setting/SettingPage';
import { CoursesPage } from '../pages/courses/CoursesPage';
import { CourseEdit } from '../pages/courses/CourseEdit';
import { Navigation } from '../components/auth/Navigation';
import { SettingImageHeader } from '../pages/setting/SettingImageHeader';
import { SettingLanguages } from '../pages/setting/SettingLanguages';
import { SettingColors } from '../pages/setting/SettingColors';
import { SettingNivels } from '../pages/setting/SettingNivels';
import { CourseDisplayRealTime } from '../pages/courses/CourseDisplayRealTime';

import { CourseStatus2 } from '../pages/courses/CourseStatus2';
import { RequestStudentsPage } from '../pages/requests/RequestStudentsPage';
import { RequestInvoicePage } from '../pages/requests/RequestInvoicePage';
import { UsuariosOnlinePage } from '../pages/usuariosOnline/UsuariosOnlinePage';
import { onlyCourse, onlyDirectors } from '../static/data';

const RedirectCursoRealtimeToCurso = () => {
    const { idCourse } = useParams();
    return <Navigate to={`/curso/${idCourse}${window.location.search}`} replace />;
};

export const AppRouter = () => {

    return (
        <Fragment>
            <BrowserRouter>
                <Navigation>
                    <Routes>
                        <Route
                            path="/signup"
                            element={
                                <PublicRoute>
                                    <SignupPage />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="/activation/:activation_token"
                            element={<ActivationPage />}

                        />
                        <Route
                            path="/login"
                            element={
                                <PublicRoute>
                                    <LoginPage />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="/pre-registro"
                            element={
                                <PublicRoute>
                                    <PreRegistrationPage />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="/forget-password"
                            element={
                                <PublicRoute>
                                    <FormForgetPasswordEmail />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="/forget-password/:token"
                            element={
                                <PublicRoute>
                                    <FormForgetPassword />
                                </PublicRoute>
                            }
                        />

                        <Route
                            path="/nuevo-usuario/:token"
                            element={
                                <PublicRoute>
                                    <AddNewUserPage />
                                </PublicRoute>
                            }
                        />


                        <Route
                            path="/"
                            element={
                                <PrivateRoute>
                                    <HomePage />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/candidatos"
                            element={
                                <PrivateRoute>
                                    <CandidatesPage />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/alumnos"
                            element={
                                <PrivateRoute>
                                    <StudentsPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/cursos"
                            element={
                                <PrivateRoute>
                                    <RouteAccess access={onlyCourse}>
                                        <CoursesPage />
                                    </RouteAccess>
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/curso-estatus/:idCourse"
                            element={
                                <PrivateRoute>
                                    <CourseStatus2 />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/curso/:idCourse"
                            element={
                                <PrivateRoute>
                                    <CourseDisplayRealTime />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/curso-realtime/:idCourse"
                            element={
                                <PrivateRoute>
                                    <RedirectCursoRealtimeToCurso />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/nuevo-curso"
                            element={
                                <PrivateRoute>
                                    <CourseEdit isCreating={true} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/editar-curso/:idCourse"
                            element={
                                <PrivateRoute>
                                    <CourseEdit isCreating={false} />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/usuarios"
                            element={
                                <PrivateRoute>
                                    <UsersPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/usuarios-online"
                            element={
                                <PrivateRoute>
                                    <RouteAccess access={onlyDirectors}>
                                        <UsuariosOnlinePage />
                                    </RouteAccess>
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/control-estudiantes"
                            element={
                                <PrivateRoute>
                                    <RequestStudentsPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/control-facturas"
                            element={
                                <PrivateRoute>
                                    <RequestInvoicePage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/pagos"
                            element={
                                <PrivateRoute>
                                    <PaymentsPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/ajustes"
                            element={
                                <PrivateRoute>
                                    <SettingPage />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/ajustes/languages"
                            element={
                                <PrivateRoute>
                                    <SettingLanguages />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/ajustes/imagenes-encabezado"
                            element={
                                <PrivateRoute>
                                    <SettingImageHeader />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/ajustes/colores"
                            element={
                                <PrivateRoute>
                                    <SettingColors />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/ajustes/niveles"
                            element={
                                <PrivateRoute>
                                    <SettingNivels />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="*"
                            element={
                                <NotFoundPage />
                            }
                        />



                    </Routes>
                </Navigation>

            </BrowserRouter >
            <ToasterProvider />
        </Fragment>

    );
};